import axios, { AxiosPromise } from 'axios';
import ApiService from '@/api/http/ApiService';
import { Tip } from '@/interfaces/models/Tip';

/**
 * Tips of a venue from the reporting service (`v1/reporting/tips`), computed
 * from the payments — the same figures as the reporting-service tips export.
 */
export default class ReportingTipsApiService extends ApiService<Tip> {
  constructor() {
    super('reporting/tips');
  }

  /** `from` / `to` are whole days (`YYYY-MM-DD`), both inclusive. */
  public getTips(venue: string, from: string, to: string): AxiosPromise<Tip> {
    return axios.get(`${this.getBaseUrl()}/${venue}/${from}/${to}`);
  }
}
